import { render, staticRenderFns } from "./SetPdf.vue?vue&type=template&id=8d49b3a6&scoped=true&"
import script from "./SetPdf.vue?vue&type=script&lang=js&"
export * from "./SetPdf.vue?vue&type=script&lang=js&"
import style0 from "./SetPdf.vue?vue&type=style&index=0&id=8d49b3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d49b3a6",
  null
  
)

export default component.exports